module.exports = __webpack_public_path__ + "img/ab-page2-img5.a30c0c42.png";